module.exports = __webpack_public_path__ + "f0ec5cc0122cb3928d572c7ad9fb618a.pdf";